var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ns-searchbar-input",
      class: { "new-header": _vm.newHeader, focused: _vm.focused }
    },
    [
      _c(
        "form",
        {
          staticClass: "searchbar-form",
          attrs: { action: "" },
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c("NsIcon", {
            staticClass: "search-icon",
            attrs: { "icon-name": "icon-search-mc", size: "custom" }
          }),
          _vm._v(" "),
          _c("input", {
            ref: "input",
            staticClass: "search-input",
            attrs: {
              id: "searchInput",
              autocomplete: "off",
              spellcheck: "false",
              type: "text",
              placeholder: _vm.placeholderText
            },
            domProps: { value: _vm.value },
            on: {
              input: function($event) {
                return _vm.$emit("input", $event)
              },
              focus: function($event) {
                return _vm.$emit("focus")
              },
              keyup: function($event) {
                return _vm.$emit("analyze-key", $event)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.value.length && !_vm.noSearchButton,
                  expression: "value.length && !noSearchButton"
                }
              ],
              staticClass: "clear-icon-container",
              on: { click: _vm.clearInput }
            },
            [
              _c("NsIcon", {
                staticClass: "clear-icon",
                attrs: {
                  "icon-name": "icon-circle-close-light",
                  size: "custom"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("NsSearchbarTooltip", {
            attrs: {
              message: _vm.translations.iconsContainerTooltip,
              disabled: !_vm.showTooltip
            },
            on: {
              close: function($event) {
                return _vm.$emit("disable-input-tooltip")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cancel-button button",
          attrs: { tabindex: "-1" },
          on: {
            click: function($event) {
              return _vm.$emit("blur")
            }
          }
        },
        [_c("span", [_vm._v(_vm._s(_vm.translations.cancel))])]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }